

























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { FillInfoItemOfForm, OperationItemType, TableColumnItemType } from '../../../types/type'
import { findItemForTree, getAllFatherNodeForTree, getArrChildForTree } from '../../../utils/toolsForCommon'
import countTo from 'vue-count-to'
import { CommonModule, UserModule } from '../../../store'
import { ElMessageComponent } from 'element-ui/types/message'
import { Pagination } from '../../../mixins/pagination'
import DateUtil from '../../../utils/toolsForDate'
@Component({
  name: 'CapitalOverview',
  mixins: [Pagination],
  components: {
    'count-to': countTo,
    'concise-card-have-title-acquiescent': () => import('../../../components/common/conciseCardHaveTitleAcquiescent.vue'),
    'table-module': () => import('../../../components/common/tableModule.vue')
  }
})
export default class CapitalOverview extends Vue {
  public dateTimeSelect: Array<string> = []
  public operationForButtonOfTableHeader: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-bottom'></span>导出资金总览列表",
      key: 'exportExcel',
      type: 'primary',
      size: '',
      canExportOutFlag: true,
      titleCopy: "<span class='el-icon-bottom'></span>导出资金总览列表",
      exportResultFileName: '资金总览列表.xlsx',
      exportLoading: "<span class='el-icon-loading'></span>正在导出中，请稍后",
      exportError: '抱歉，导出失败',
      exportSuccess: '导出成功'
    }
  ]
  public loadingForInformationOverviewContent: boolean = false
  public informationOverviewMoney: Array<FillInfoItemOfForm> = [
    {
      title: '划转城投账户资金总额',
      key: 'totalAmount',
      content: '',
      bgc: '#BFEDD6'
    },
    {
      title: '已申请使用资金总额',
      key: 'usedAmount',
      content: '',
      bgc: '#73E0E4'
    },
    {
      title: '已拨付资金',
      key: 'appliedAmount',
      content: '',
      bgc: '#C1BAFB'
    },
    {
      title: '待拨付资金',
      key: 'appropriatingAmount',
      content: '',
      bgc: '#F8B594'
    },
    {
      title: '余额',
      key: 'balance',
      content: '',
      bgc: '#A2E676'
    }
  ]
  public filterText: string = ''
  public loadingForTableModule: boolean = false
  // 列表列有哪些：
  public tableColumnList: Array<TableColumnItemType> = [
    {
      title: '乡镇',
      key: 'townName',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    },
    {
      title: '学校',
      key: 'orgId',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      needTransformForResult: 'enum'
    },
    {
      title: '划转城投账户资金总额',
      key: 'totalAmount',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    },
    {
      title: '已申请使用资金总额',
      key: 'usedAmount',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    },
    {
      title: '已拨付资金',
      key: 'appliedAmount',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    },
    {
      title: '待拨付资金',
      key: 'appropriatingAmount',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    },
    {
      title: '余额',
      key: 'balance',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    }
  ]
  // 列表每一行的操作有哪些：
  public columnOperationList: Array<OperationItemType> = []

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get userInfo () {
    return UserModule.userInfo
  }

  get orgName (): string {
    const org = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
    return org && org['name'] ? org['name'] : '- -'
  }

  get allRole () {
    return (this as any).$RoleCode
  }

  get userInfoAuthority (): Array<number> {
    return UserModule.userInfo ? UserModule.userInfo.resultAuthorityList : []
  }

  get operationForButtonOfTableHeaderDispose () {
    let res = 1
    // 这里需要判断权限，
    // 只有城投审核岗位和城投拨付岗才会有：
    // 食堂资金管理后勤端：
    const {
      CapitalCounty,
      CapitalCityInvestment
    } = this.allRole
    // 食堂资金管理后勤端：
    const CapitalCountyRes = Object.keys(CapitalCounty).filter(item => {
      if (this.userInfoAuthority.includes(CapitalCounty[item].code)) {
        return item
      }
    })
    // 食堂资金管理城投端：
    const CapitalCityInvestmentRes = Object.keys(CapitalCityInvestment).filter(item => {
      if (this.userInfoAuthority.includes(CapitalCityInvestment[item].code)) {
        return item
      }
    })
    if (CapitalCountyRes.length) {
      res = 1
    }
    if (CapitalCityInvestmentRes.length) {
      res = 2
    }
    if (res === 1) {
      return [
        {
          title: "<span class='el-icon-bottom'></span>导出资金总览列表",
          key: 'exportExcel',
          type: 'primary',
          size: '',
          canExportOutFlag: true,
          titleCopy: "<span class='el-icon-bottom'></span>导出资金总览列表",
          exportResultFileName: '资金总览列表.xlsx',
          exportLoading: "<span class='el-icon-loading'></span>正在导出中，请稍后",
          exportError: '抱歉，导出失败',
          exportSuccess: '导出成功'
        }
      ]
    } else if (res === 2) {
      return [
        {
          title: "<span class='el-icon-bottom'></span>导出资金总览列表",
          key: 'exportExcel',
          type: 'primary',
          size: '',
          canExportOutFlag: true,
          titleCopy: "<span class='el-icon-bottom'></span>导出资金总览列表",
          exportResultFileName: '资金总览列表.xlsx',
          exportLoading: "<span class='el-icon-loading'></span>正在导出中，请稍后",
          exportError: '抱歉，导出失败',
          exportSuccess: '导出成功'
        }
      ]
    }
  }

  @Watch('filterText') filterTextChange (val: any) {
    ;(this.$refs.tree as any).filter(val)
  }

  created () {
    this.dateTimeSelect = [DateUtil.getStartDayOfMonth(), DateUtil.getNowDay()]
  }

  async mounted () {
    await Promise.all([
      CommonModule.getTreeDataForSubOrganization(),
      CommonModule.getTreeDataForOrganization()
    ])
    this.$nextTick(() => {
      ;(this as any).$refs.tree.setCheckedKeys(getArrChildForTree(this.treeDataForSubOrganatizion, 'children').map(item => item.id))
      this.getDetailInfo()
    })
  }

  filterNode (value: any, data: any) {
    if (!value) return true
    return data.name.indexOf(value) !== -1
  }

  changeDateTimeSelect () {
    this.getDetailInfo()
  }

  handleCheckChange (): void {
    this.getDetailInfo()
  }

  async getDetailInfo (): Promise<ElMessageComponent | void> {
    try {
      const dateObj = this.dateTimeSelect.length ? this.dateTimeSelect : [DateUtil.getStartDayOfMonth(), DateUtil.getNowDay()]
      const [startTime, endTime] = dateObj
      const params = {
        startTime,
        endTime,
        orgIds: (this as any).$refs.tree.getCheckedKeys(true)
      }
      this.loadingForInformationOverviewContent = true
      this.loadingForTableModule = true
      const { data: result } = await (this as any).$http.capitalAgg(params)
      this.loadingForInformationOverviewContent = false
      this.loadingForTableModule = false
      if (result.code !== 200) return this.$message.error(result.msg)
      // 处理常规数据的格式 start ***：
      ;(this as any).tableDataList = (result.data || []).map(item => {
        // 为了获取乡镇：
        const chooseItemForAllFather = getAllFatherNodeForTree(this.treeDataForOrganatizion, 'children', 'id', item.orgId)
        // 拿到乡镇的id:
        let idForTown = chooseItemForAllFather[chooseItemForAllFather.length - 2]
        if (idForTown) {
          const resForTown = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', idForTown)
          if (resForTown) {
            item['townName'] = (resForTown as any).name
          }
        }
        return item
      })
      // 处理常规数据的格式 end ***
      let totalAmountRes = 0
      let usedAmountRes = 0
      let appliedAmountRes = 0
      let appropriatingAmountRes = 0
      let balanceRes = 0
      ;(result.data || []).forEach(item => {
        totalAmountRes += (Number(item.totalAmount) * 1000000)
        usedAmountRes += (Number(item.usedAmount) * 1000000)
        appliedAmountRes += (Number(item.appliedAmount) * 1000000)
        appropriatingAmountRes += (Number(item.appropriatingAmount) * 1000000)
        balanceRes += (Number(item.balance) * 1000000)
      })
      const map = new Map()
      map.set('totalAmount', totalAmountRes / 1000000)
      map.set('usedAmount', usedAmountRes / 1000000)
      map.set('appliedAmount', appliedAmountRes / 1000000)
      map.set('appropriatingAmount', appropriatingAmountRes / 1000000)
      map.set('balance', balanceRes / 1000000)
      this.informationOverviewMoney = this.informationOverviewMoney.map(item => {
        const { key } = item
        item.content = map.get(key)
        return item
      })
    } catch (err) {
      console.log(err)
    }
  }

  operationForButton ({ key }, row?) {
    switch (key) {
      case 'exportExcel':
        // 开始导出：纯前端导出
        this.operationForButtonOfTableHeader.forEach(async item => {
          if (item.key === 'exportExcel') {
            if (!item.canExportOutFlag) return this.$message.error('请等待上一次请求完成！')
            item.canExportOutFlag = false
            item.title = item.exportLoading
            // start:
            const keysList = this.tableColumnList.map(v => v.key)
            const dataRes = ((this as any).tableDataList || []).map(v => {
              return keysList.map(vv => {
                let res = ''
                switch (vv) {
                  case 'orgId':
                    const NodeRes = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', v[vv])
                    if (!Object.keys(NodeRes).length) {
                      res = '- -'
                    } else {
                      res = NodeRes['name']
                    }
                    break
                  default:
                    res = v[vv]
                }
                return res
              })
            })
            import('../../../plugins/xlsx/exportExcel').then(excel => {
              let tHeader = this.tableColumnList.map(v => v.title)
              try {
                excel.export_json_to_excel({
                  multiHeader2: [], // 这里是第一行的表头
                  multiHeader: [], // 这里是第二行的表头
                  header: tHeader, // 这里应该是算第三行的表头
                  data: dataRes,
                  merges: [],
                  filename: item.exportResultFileName
                })
                this.$message.success(item.exportSuccess)
                item.canExportOutFlag = true
                item.title = item.titleCopy
              } catch (err) {
                this.$message.error(item.exportError)
                item.canExportOutFlag = true
                item.title = item.titleCopy
              }
            })
            // end
          }
        })
        break
    }
  }
}
